import {observer} from "mobx-react";
import SearchInput from "../../../components/search-input/search-input";
import './order-search.scss';
import {CreateRmaMainStore} from "../stores/create-rma-main-store";

interface IProps {
	createRmaMainStore: CreateRmaMainStore;
}

const OrderSearch: React.FC<IProps> = observer(({ createRmaMainStore }) => {

	const onSearchClick = (() => {
		createRmaMainStore.searchForOrder();
	});
	
	const onSearchChange = ((value: string) => {
		createRmaMainStore.setSearchOrderName(value);
	});

	/** C-RMA functionality is disabled when setting were not loaded yet or if no allowed modes */
	const disabled = !createRmaMainStore.settings.wasLoaded || createRmaMainStore.settings.getCRmaModeOptions().length === 0;

	return (
		<div className='order-search'>
			<div className={'order-search-input'}>
				<SearchInput value={createRmaMainStore.searchOrderName ?? ''}
					onClick={onSearchClick}
					isSearching={createRmaMainStore.isSearching}
					placeholder={'Search for an order'}
					searchError={createRmaMainStore.searchError ? {message: createRmaMainStore.searchError} : undefined}
					onChange={onSearchChange}
					disabled={disabled}
				/>
			</div>
		</div>
	)
})
export default OrderSearch;
